import { AsyncPipe, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SkeletonLoaderModule } from 'src/app/shared/components/skeleton-loader/skeleton-loader.module';
import {
  ICON_CHECK_CIRCLE,
  ICON_CHEVRON_DOWN,
  ICON_CLOSE, ICON_CLOSE_CIRCLE
} from 'src/app/shared/named-icons.config';
import { ToastService } from 'src/app/toast/toast.service';
import { TasksQueueCardComponent } from '../../card/tasks-queue-card.component';
import { AutoAcceptBannersStore, BannerAcceptStatuses } from './auto-accept-banners.store';
import { AutoAcceptBannersItemSkeletonComponent } from './item-skeleton/auto-accept-banners-item-skeleton.component';

@Component({
  selector: 'app-auto-accept-banners',
  templateUrl: 'auto-accept-banners.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    InlineSVGModule,
    TasksQueueCardComponent,
    NgIf,
    AutoAcceptBannersItemSkeletonComponent,
    SkeletonLoaderModule,
    NgForOf,
    AsyncPipe,
    TranslateModule,
    NgSwitchCase,
    NgSwitch,
    NgSwitchDefault
  ],
  providers: [
    AutoAcceptBannersStore,
  ],
})
export class AutoAcceptBannersComponent implements OnInit, OnDestroy {
  @Input()
  public campaignId: number;

  public readonly ICON_CLOSE = ICON_CLOSE;
  public readonly ICON_CHEVRON_DOWN = ICON_CHEVRON_DOWN;
  public readonly ICON_CHECK_CIRCLE = ICON_CHECK_CIRCLE;
  public readonly ICON_CLOSE_CIRCLE = ICON_CLOSE_CIRCLE;
  public readonly ACCEPT_STATUSES = BannerAcceptStatuses;

  public readonly componentStore = inject(AutoAcceptBannersStore);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);
  private readonly destroyed$: Subject<void> = new Subject();

  public ngOnInit(): void {
    this.componentStore.fetchBanners(this.campaignId);
    this.componentStore.areAllBannersFinished$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([hasSuccess, hasFailures]) => {
        if (hasSuccess) {
          this.toastService.success(
            this.translateService.instant('CAMPAIGNS.CREATE_WIZARD.AUTO_MODERATION.TASK_SUCCESS')
          );
        }

        if (hasFailures) {
          this.toastService.error(
            this.translateService.instant('CAMPAIGNS.CREATE_WIZARD.AUTO_MODERATION.TASK_FAILED')
          );
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
